// eslint-disable-next-line import/no-extraneous-dependencies



import { useScrollToTop } from 'src/hooks/use-scroll-to-top';

import 'src/global.css';
import 'src/locales/i18n';
import ThemeProvider from 'src/theme';

import ProgressBar from 'src/components/progress-bar';
import { SettingsProvider } from 'src/components/settings';
import { MotionLazy } from 'src/components/animate/motion-lazy';

import Router from './routes/sections';
import { useApp } from './hooks/use-app';
import useFirebase from './hooks/use-firebase';
import { LocalizationProvider } from './locales';
import { SnackbarProvider } from './components/snackbar';
import { SplashScreen } from './components/loading-screen';

export default function App() {
  useScrollToTop();
  const { isLoading } = useApp();
  useFirebase();

  return (
    isLoading.value ? <SplashScreen /> :
      <LocalizationProvider>
        <SettingsProvider
          defaultSettings={{
            themeMode: 'light', // 'light' | 'dark'
            themeDirection: 'ltr', //  'rtl' | 'ltr'
            themeContrast: 'default', // 'default' | 'bold'
            themeLayout: 'horizontal', // 'vertical' | 'horizontal' | 'mini'
            themeColorPresets: 'default', // 'default' | 'cyan' | 'purple' | 'blue' | 'orange' | 'red'
            themeStretch: false,
          }}
        >
          <ThemeProvider>
            <MotionLazy>
              <SnackbarProvider>
                <ProgressBar />
                <Router />
              </SnackbarProvider>
            </MotionLazy>
          </ThemeProvider>
        </SettingsProvider>
      </LocalizationProvider>
  );
}
